import Vue from 'vue'
import Router from 'vue-router'
import * as cache from '@/utils/cache'

import base from './base'
import platform from './platform'
import pub from './pub'
import rb from './rb'
import wk from './wk'
import task from './task'
import data from './data'
import mitr from './mitr'

// Progress 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(Router);

let rout = [
  {
    path: '',
    redirect: '/login',
    meta: {title: '管理端登录', keepAlive: true}
  },
  {
    path: '/login',
    name: 'login',
    meta: {title: '管理端登录'},
    component: () => import('@/pages/login/login')
  },
  {
    path: '/index',
    name: 'index',
    meta: {title: '系统主页', keepAlive: false},
    component: () => import('@/pages/layout/espIndex')
  },
  {
    path: '/home',
    name: 'home',
    meta: {title: '首页', isIndex: true, keepAlive: true},
    component: () => import('@/pages/task/overview/index.vue')
  }
];

// 基础模块
base.forEach(function (item, index) {
  rout.push(item);
});
// 平台模块
platform.forEach(function (item, index) {
  rout.push(item);
});
// 基本信息
pub.forEach(function (item, index) {
  rout.push(item);
});

rb.forEach(function (item, index) {
  rout.push(item);
});

task.forEach(function (item, index) {
  rout.push(item);
});

wk.forEach(function (item, index) {
  rout.push(item);
});

data.forEach(function (item, index) {
  rout.push(item);
});

mitr.forEach(function (item, index) {
  rout.push(item);
});



/**
 * 前端路由，权限控制
 * 1. 没有token直接去登录
 * 2. 有token，再看有没有本地数据，如果没有就刷新
 * 3. 控制前端白名单
 */
const whiteList = ['/login'];
const router = new Router({routes: rout});
router.beforeEach((to, from, next) => {
  NProgress.start();
  var token = cache.getToken();
  // 1. 没有登录
  if (token == undefined || token == null || token == '') {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      window.location.href = '/'
    }
  }
  // 2. 登录后
  else {
    next()
  }
});

// 跳转后，关闭加载
router.afterEach(() => {
  NProgress.done();
});

// 解决点击同一个连接报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js